import { ClubHttpHelper, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';

const PutUsasClubAndHelperObjData = (usasClubId, clubObj, helperObj, state, setState) => {
  if (state.isSaving !== true && !state.message) {
    const newState = {
      ...state,
      helperObj,
      isSaving: true,
      isSaved: false,
      message: 'Saving...'
    };
    setState(newState);

    const usasClubIdForUrl = usasClubId ? encodeURIComponent(usasClubId) : 'NaN';
    const url = `/UsasClub/${usasClubIdForUrl}/baseusasClub`;
    ClubHttpHelper(url, 'PUT', clubObj)
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            helperObj,
            isObjLoaded: true,
            isSaving: false,
            isSaved: true,
            objData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isObjLoaded: false,
          isSaving: false,
          isSaved: false,
          message: message
        });
      });
  }
};

export default PutUsasClubAndHelperObjData;